enum ApiActionEnum {
    CREATE_CI = "createCi",
    CREATE_RGPD = "createRGPD",
    CREATE_DD = "createDD",
    RATIFY_CI = "ratificateCi",
    RESEND_CI = "reSendCi",
  }

  export default ApiActionEnum;